import { createAction, props } from '@ngrx/store';
import { PaymentMandateResponse } from '../models/payment-mandate.model';

export const loadAcceptDebitOrderMandates = createAction(
  '[AcceptDebitOrderMandate] Load AcceptDebitOrderMandates',
  props<{ businessId: string; mandate: PaymentMandateResponse }>()
);

export const loadAcceptDebitOrderMandatesSuccess = createAction(
  '[AcceptDebitOrderMandate] Load AcceptDebitOrderMandates Success',
  props<{ response: any }>()
);

export const loadAcceptDebitOrderMandatesFailure = createAction(
  '[AcceptDebitOrderMandate] Load AcceptDebitOrderMandates Failure',
  props<{ error: Error | any }>()
);
